import { TenantUtilities } from "@core/utilities";

export class DefaultRoutes {
  static readonly Empty: string = '';
  static readonly Wildcard: string = '**';

  static readonly AdminLogin: string = 'admin/login';
  static readonly KioskLogin: string = 'kiosk/login';

  static readonly TenantParam: string = ':tenantName';
  static readonly Default: string = `${TenantUtilities.default_tenant}/kiosk`;
}